import * as React from 'react';
const SvgEditPenOutlined = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 24 24"
		width="1em"
		height="1em"
		{...props}
	>
		<path
			fill="#60636B"
			fillRule="evenodd"
			d="M19.08 3.33a1.125 1.125 0 0 1 1.59 1.59l-1.086 1.087a.1.1 0 0 1-.141 0l-1.45-1.45a.1.1 0 0 1 0-.141zM16.79 5.618a.1.1 0 0 1 .141 0l1.45 1.45a.1.1 0 0 1 0 .141l-8.33 8.33a3.75 3.75 0 0 1-1.581.942l-1.18.352a.1.1 0 0 1-.124-.125l.352-1.179a3.75 3.75 0 0 1 .942-1.58zm4.94-3.35a2.625 2.625 0 0 0-3.712 0L16.33 3.957l-8.93 8.931a5.25 5.25 0 0 0-1.32 2.214l-.8 2.685a.75.75 0 0 0 .933.933l2.685-.8a5.25 5.25 0 0 0 2.214-1.32L21.73 5.982a2.625 2.625 0 0 0 0-3.712M3.75 8.25a1.5 1.5 0 0 1 1.5-1.5H10a.75.75 0 0 0 0-1.5H5.25a3 3 0 0 0-3 3v10.5a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3V14a.75.75 0 0 0-1.5 0v4.75a1.5 1.5 0 0 1-1.5 1.5H5.25a1.5 1.5 0 0 1-1.5-1.5z"
			clipRule="evenodd"
		/>
	</svg>
);
export default SvgEditPenOutlined;
